import { PublicTeam } from "../../models/groupedTeams";
import { Team } from "../../models/teamModel";
import Avatar from "../Avatar";
import { OverlappingAvatars } from "../OverlappingAvatars";
export const TeamHeader = ({ team, hideAvatar }: { team?: Team | PublicTeam, 
  hideAvatar?: boolean;

 }) => {
  if (!team) {
    return <div className="flex-1">No team</div>;
  }
  return (
    <div className="flex items-center place-content-between m-3 flex-wrap">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 flex-shrink-0">
          <Avatar
            firstName={team.name}
            lastName=""
            imageUrl={`/api/static/images/${team.logo}`}
            className="h-11 w-11 rounded-full"
          />
        </div>
        <div className="leading-none flex flex-col">
          <div className="text-lg font-semibold text-gray-900 dark:text-gray-100 text-ellipsis w-full">
            {team.name}
          </div>
        </div>
      </div>
      {!hideAvatar && (
        <OverlappingAvatars users={[...team.members].reverse()} />
      )}
    </div>
  );
};
